import { en } from './locales/en';
import { es } from './locales/es';
import { de } from './locales/de';
import { pt } from './locales/pt';
import { it } from './locales/it';
import { fr } from './locales/fr';

export const DEFAULT_LOCALE = 'es';
export const STORAGE_KEY = 'bringy2-locale';

export const LANGUAGES = [
  { code: 'en', label: 'English', short: 'EN' },
  { code: 'es', label: 'Español', short: 'ES' },
  { code: 'de', label: 'Deutsch', short: 'DE' },
  { code: 'pt', label: 'Português', short: 'PT' },
  { code: 'it', label: 'Italiano', short: 'IT' },
  { code: 'fr', label: 'Français', short: 'FR' },
];

export const translations = { en, es, de, pt, it, fr };

export function isLocale(value) {
  return Object.prototype.hasOwnProperty.call(translations, value);
}

export function detectLocale() {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored && isLocale(stored)) return stored;
  const browser = navigator.language.slice(0, 2);
  if (isLocale(browser)) return browser;
  return DEFAULT_LOCALE;
}

export function formatCopyright(template, year) {
  if (template == null || typeof template !== 'string') {
    return `© ${year} Bringy`;
  }
  return template.replace('{year}', String(year));
}
